import ServicePage from "../Common/ServicePage";

// Water purifier specific services
const waterPurifierServices = [
  { 
    id: 1, 
    name: 'Basic Water Purifier Installation', 
    provider: 'AquaPure Solutions', 
    image: 'https://placehold.co/600x400?text=Basic+Installation', 
    rating: 4.8, 
    reviews: 1200, 
    price: 500, 
    category: 'Installation' 
  },
  { 
    id: 2, 
    name: 'Premium RO Purifier Installation', 
    provider: 'PureWater Experts', 
    image: 'https://placehold.co/600x400?text=Premium+RO', 
    rating: 4.85, 
    reviews: 900, 
    price: 800, 
    category: 'Installation' 
  },
  { 
    id: 3, 
    name: 'Water Purifier Repair', 
    provider: 'FixIt Professionals', 
    image: 'https://placehold.co/600x400?text=Repair+Service', 
    rating: 4.7, 
    reviews: 750, 
    price: 300, 
    category: 'Repair' 
  },
  { 
    id: 4, 
    name: 'RO Membrane Replacement', 
    provider: 'WaterCare Specialists', 
    image: 'https://placehold.co/600x400?text=Membrane+Replace', 
    rating: 4.9, 
    reviews: 600, 
    price: 250, 
    category: 'Maintenance' 
  },
  { 
    id: 5, 
    name: 'Annual Maintenance Contract', 
    provider: 'AquaGuard Services', 
    image: 'https://placehold.co/600x400?text=AMC', 
    rating: 4.8, 
    reviews: 1100, 
    price: 1200, 
    category: 'Maintenance' 
  }
];

const waterPurifierCategories = ['Installation', 'Repair', 'Maintenance', 'Replacement'];

const packages = [
  { id: 1, title: "Basic Water Purifier Installation", rating: "4.80 (1.2k reviews)", price: 500, originalPrice: 650, icon: "plumbing" },
  { id: 2, title: "Premium RO Purifier Installation", rating: "4.85 (900 reviews)", price: 800, originalPrice: 950, icon: "water_drop" },
];

const miniServices = [
  { id: 101, title: "Wall Mount Installation", price: 200, icon: "build" },
  { id: 102, title: "Countertop Installation", price: 150, icon: "countertops" },
];

export default function WaterPurifierInstallation() {
  return (
    <ServicePage
      serviceName="Water Purifier Installation"
      packages={packages}
      miniServices={miniServices}
      customServices={waterPurifierServices}
      customCategories={waterPurifierCategories}
      isCustomService={true}
    />
  );
}